export * from '@primeuix/themes/material/checkbox';
export { default } from '@primeuix/themes/material/checkbox';
